<template>
  <v-app :style="cssVars">
    <SkipLink />
    <header>
      <v-row style="background-color: var(--home-header-background)">
        <v-col
          class="col-auto mr-auto header py-1"
          v-if="$vuetify.breakpoint.mobile"
        >
          <router-link to="/" :aria-label="`${$city.name}健檢預約平台，回首頁`">
            <v-img
              class="mobile-logo"
              height="70px"
              width="70px"
              contain
              :src="`./images/logo/${$city.name}/logo.png`"
              :alt="`${$city.name}健檢預約平台`"
            ></v-img>
          </router-link>
        </v-col>
        <v-col class="col-auto mr-auto header py-0" v-else>
          <router-link to="/" :aria-label="`${$city.name}政府健檢預約平台，回首頁`">
            <v-img
              height="83px"
              width="195px"
              contain
              :src="`./images/logo/${$city.name}/city.png`"
              :alt="`${$city.name}政府健檢預約平台`"
            ></v-img>
          </router-link>
        </v-col>
        <v-col class="col-auto mt-9 py-0 font-weight-bold">
          <a
            class="external-link"
            :href="$city.govURL"
            target="_blank"
            rel="noopener"
            :title="`${$city.name}政府（另開新視窗）`"
            :aria-label="`${$city.name}政府（另開新視窗）`"
          >
            {{ $city.name }}政府<span class="sr-only">（另開新視窗）</span>
          </a>
        </v-col>
        <v-col class="col-auto mt-9 mr-4 py-0 font-weight-bold">
          <a
            class="external-link"
            :href="$city.healthURL"
            target="_blank"
            rel="noopener"
            :title="`${$city.name}衛生局（另開新視窗）`"
            :aria-label="`${$city.name}衛生局（另開新視窗）`"
          >
            {{ $city.name }}衛生局<span class="sr-only">（另開新視窗）</span>
          </a>
        </v-col>
      </v-row>
      <v-row justify="end" class="sub-header">
        <!-- <v-col class="col-auto ml-auto pointer">資格查詢與預約</v-col>
        <v-col class="col-auto mr-4 pointer">預約紀錄查詢</v-col> -->
        <v-col class=""></v-col>
      </v-row>
    </header>
    <v-main id="main-content" tabindex="-1">
      <router-view />
    </v-main>
    <Announcement type="announcement" />
    <footer class="text-center d-flex flex-column justify-center py-4 mt-4">
      <div class="mb-2">
        <router-link class="footer-link" to="/sitemap">網站導覽</router-link>
      </div>
      <div v-for="address of $city.addresses" :key="address.address">
        {{ address.address }}
        <template v-if="$vuetify.breakpoint.mobile"><br /></template>
        <template v-else>｜</template>
        電話：{{ address.phone }}
      </div>

      <div>最佳瀏覽解析度 1024 x 800，不支援 IE 版本</div>
    </footer>
  </v-app>
</template>

<script>
import Announcement from "@/components/Common/Announcement.vue";
import SkipLink from "@/components/Common/SkipLink.vue";

export default {
  name: "ReserveTemplate",
  components: {
    Announcement,
    SkipLink,
  },
  methods: {},
  created() {},
  computed: {
    cssVars() {
      return this.$city.style;
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  color: #00427b;
}
.external-link {
  color: inherit;
  text-decoration: none;
}
.external-link:hover {
  text-decoration: underline;
}
.mobile-logo {
  position: relative;
  top: 8px;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.sub-header {
  background-color: var(--home-bar-background);
  color: #fff;
  font-size: 1.25rem;
}
footer {
  font-size: 1rem;
  color: #fff;
  background-color: #000;
  min-height: 100px;
}
.footer-link {
  color: #fff;
}
</style>
